import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private _router: Router) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (AppStorageUtil.getItem('User2')) {
        return true;
      } else {

        this._router.navigate(['/auth/login/simple'], { queryParams: { returnUrl: state.url }} );
        return false;
      }
  }

}
